// extracted by mini-css-extract-plugin
export var container = "layout-module--container--TynrU";
export var hardWraps = "layout-module--hard-wraps--8s7qF";
export var hero = "layout-module--hero--9JOXz";
export var layout = "layout-module--layout--FDAH1";
export var main = "layout-module--main--GXHFS";